module.exports = __webpack_public_path__ + "static/media/SOTA SAPHIRE VII.c7686201.png";